let findFriendSection, heardAboutUsSection;
window.heardAboutUsValues = window.heardAboutUsValues || [];
window.isOtherOptionSelected = window.isOtherOptionSelected || false;
window.otherOptionSelectedValue = window.otherOptionSelectedValue || '';

function showFindFriendSection(e) {
    if(e) e.preventDefault();
    if($('#integrated-referral-form').length) {
        if($('#integrated-referral-form-saved').length) {
            $('#integrated-referral-form-saved').val('false');
        }
        heardAboutUsSection.addClass('d-none');
        findFriendSection.removeClass('d-none');
        $('#referred-us-choice-btn-no').removeClass('selected');
        $('#referred-us-choice-btn-yes').addClass('selected');
        const $blocks = $('#nameSearch, #phoneSearch, #memberIdSearch');
        const allHidden = $blocks.filter(':not(.d-none)').length === 0;
        if(allHidden) {
            toggleSearchBlocks('name');
        }

        uncheckHeardAboutUsOptions();
    }
}

function showHeardAboutUsSection(e) {
    if(e) e.preventDefault();
    if($('#integrated-referral-form').length) {
        if($('#integrated-referral-form-saved').length) {
            $('#integrated-referral-form-saved').val('false');
        }
        findFriendSection.addClass('d-none');
        heardAboutUsSection.removeClass('d-none');
        $('#referred-us-choice-btn-no').addClass('selected');
        $('#referred-us-choice-btn-yes').removeClass('selected');
        resetReferralSearch();
    }
}

function uncheckHeardAboutUsOptions() {
    $('.heard-about-us-options input[name="heard_about_us"]').prop('checked', false);
    window.heardAboutUsValues = [];
    $('#heard_about_us_other_option').val('');
    window.isOtherOptionSelected = false;
    window.otherOptionSelectedValue = '';
}

function toggleSearchBlocks(value) {
    const $target = $('#' + value + 'Search');
    if(!$target.length) return;

    $('#nameSearch, #phoneSearch, #memberIdSearch').addClass('d-none');
    $target.removeClass('d-none');
    resetReferralSearch();
    if($('#integrated-referral-form-saved').length) {
        $('#integrated-referral-form-saved').val('false');
    }
}

function resetReferralSearch() {
    if($('#integrated-referral-form').length) {
        const $findFriendSection = $('#findFriendSection');
        if(!$findFriendSection.hasClass('d-none')) {
            $findFriendSection.find('.search-error-alert-faf').addClass('d-none');
        }
        let $friendList = $('.self-enrollment__friend-list');
        if($friendList.length) {
            if(!$friendList.hasClass('modernized')) {
                $friendList.empty();
            } else {
                $friendList.find('.referral-no-results-found').remove();
                $friendList.find('.self-enrollment__friends-count, ul').remove();
                $friendList.removeClass('has-results has-no-results');
            }
        }

        $('.referred-us-enroll-section .self-enrollment__friend-search input').val('');
        $('.referred-us-enroll-section .self-enrollment__friend-search input').each(function () {
            $(this).siblings(`label[for="${this.id}"]`).removeClass('is--active');
        });

        $('.referred-us-enroll-section .self-enrollment__friend-search select').val('default');
        const defaultcountry = $('.referred-us-enroll-section select#phoneCountryFriend').data('defaultcountry');
        $('.referred-us-enroll-section .self-enrollment__friend-search select#phoneCountryFriend').val(defaultcountry);
        $('.referred-us-enroll-section .self-enrollment__friend-search .form-block').removeClass('is--error');
        $('.referred-us-enroll-section .self-enrollment__friend-search .mod-field').removeClass('mod-field--error');
        $('.referred-us-enroll-section .self-enrollment__friend-search .mod-dropdown__select-wrap').removeClass('is--error');
        $('.account-referral-form-required-message-element').remove();
    }
}

function clearErrorOnInput() {
    $(this).closest('.form-block').removeClass('is--error');
    $(this).closest('.mod-field').removeClass('mod-field--error');
    const $selectWrap = $(this).closest('.mod-dropdown__select-wrap');
    $selectWrap.removeClass('is--error').next('.account-referral-form-required-message-element').remove();
    $(this).siblings('.account-referral-form-required-message-element').remove();
}

function storeHeardAboutUsValues() {
    const $checkbox = $(this);
    const key = $checkbox.attr('data-guid');
    const value = $checkbox.val();
    window.heardAboutUsValues = window.heardAboutUsValues || [];
    if(this.checked) {
        window.heardAboutUsValues.push({ Id: key, Value: value });
    } else {
        window.heardAboutUsValues = window.heardAboutUsValues.filter(
            x => x.Id !== key
        );
    }

    if($('#integrated-referral-form-saved').length) {
        $('#integrated-referral-form-saved').val('false');
    }
}

function storeOtherTextBoxValue() {
    const value = $(this).val().trim();
    window.isOtherOptionSelected = false;
    window.otherOptionSelectedValue = '';
    if(value) {
        $('#integrated-referral-form-saved').val('false');
        window.isOtherOptionSelected = true;
        window.otherOptionSelectedValue = value;
    }
}

function debounce(func, wait = 200) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

function initEventHandler() {
    findFriendSection = $('#findFriendSection');
    heardAboutUsSection = $('#heardAboutUs');

    // delegate from both legacy and modernized layout containers
    $('.enroll-section, .checkout-v2')
        .on('click', '#referred-us-choice-btn-yes', showFindFriendSection)
        .on('click', '#referred-us-choice-btn-no', showHeardAboutUsSection);

    $('input[name="searchBy"]').on('change', function () {
        toggleSearchBlocks(this.value);
    });
    $('.self-enrollment__friend-search').on('input change', 'input, select', clearErrorOnInput);

    $('input[name="heard_about_us"]').on('change', storeHeardAboutUsValues);
    $('#heard_about_us_other_option').on('input', debounce(storeOtherTextBoxValue, 200));
}

$(initEventHandler);
